import styled from "styled-components";

export const HtmlContent = styled.div`
  & h2 {
    font-family: Poppins, sans-serif;
    font-weight: 100;
    color: #0b0b0b;
    font-size: 30px;
    line-height: 1.25;
    margin-top: 10px;
    margin-bottom: 0.25em;

    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      font-size: 35px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 40px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: 50px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
      font-size: 60px;
    }
  }
`;
